(function(_) {

    app.constant("_", _); 

})(window._);